// extracted by mini-css-extract-plugin
module.exports = {"header":"_3PL8ZBBVtkdVsJ-Mqlx661","subtitle":"ExwEKoyWHpbpbe8urSJDT","logo":"_1lZb2lOoDJqWgd9MxvINtI"};